import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { YStack } from "tamagui";

import AuthScaffold from "@/components/AuthScaffold";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { AppButton, AppFieldGroup, AppInput } from "../../ui-foundation";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error("Password needs to be at least 6 characters");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (error) {
      toast.error(error.message);
      return;
    }

    toast.success("Your password is updated. Welcome back.");
    navigate("/kinfeed");
  };

  return (
    <AuthScaffold
      eyebrow="Set a new password"
      title="Choose something secure, then carry on."
      description="Use at least six characters. Once it's updated, you'll be able to head straight back into Kindred."
    >
      <YStack tag="form" onSubmit={handleUpdate} gap="$sm">
        <AppFieldGroup label={<label htmlFor="password">New password</label>}>
          <AppInput
            id="password"
            type="password"
            value={password}
            onChangeText={setPassword}
            placeholder="At least 6 characters"
            autoComplete="new-password"
          />
        </AppFieldGroup>

        <AppFieldGroup label={<label htmlFor="confirmPassword">Confirm password</label>}>
          <AppInput
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChangeText={setConfirmPassword}
            placeholder="Repeat your password"
            autoComplete="new-password"
          />
        </AppFieldGroup>

        <AppButton type="submit" disabled={loading} width="100%">
          {loading ? "Updating..." : "Update password"}
        </AppButton>
        <Link to="/login-support" className="kindred-inline-link" style={{ textAlign: "center" }}>
          Password still will not update? Get support
        </Link>
      </YStack>
    </AuthScaffold>
  );
};

export default UpdatePassword;
